import { z } from 'zod';

import { createFileRoute } from '@tanstack/react-router';

import { ProcedureInterface } from './-components/procedures-interface'; 

export const proceduresSearchSchema = z.object({
  displayName: z.string({ description: 'Name' }).optional(),
});

export const Route = createFileRoute('/dashboard/admin/procedures/')({
  component: View,

  validateSearch: proceduresSearchSchema,
});

function View() {
  return <ProcedureInterface />;
}
